<template>
    <div>
        <CollapseConfirmData
            :codeId="code"
            :isShowButton="false"
            @removeService="removeService"
        >
            <template #content>
                <h4 class="mb-2.5 md:mb-4">
                    信用卡資訊
                </h4>

                <ResultList class="md:hidden break-all">
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            授權人(即持卡人)/身分證統一證號
                        </p>
                        <span class="text-gray-900"> {{ holderId }}</span><br>
                        <span class="text-gray-900"> {{ holderName }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            發卡機構
                        </p>
                        <span class="text-gray-900"> {{ data.after.cardBankName }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3 flex-shrink-0">
                            卡號
                        </p>
                        <span class="text-gray-900"> {{ formatCreditCardNo(data.after.cardNo) }}</span>
                    </li>
                    <li class="flex items-center">
                        <p class="w-28 sm:w-1/3 text-sm mr-3  flex-shrink-0">
                            有效月年
                        </p>
                        <span class="text-gray-900">{{ `${data.after.fullMonth}月 / ${data.after.fullYear}年` }} </span>
                    </li>
                </ResultList>

                <TableBase
                    class="hidden md:block"
                    :isDashed="true"
                    :cursorPointer="false"
                >
                    <template #thead>
                        <tr class="text-sm lg:text-base">
                            <th>
                                授權人(即持卡人)/身分證統一證號
                            </th>
                            <th>
                                發卡機構
                            </th>
                            <th>
                                卡號
                            </th>
                            <th>
                                有效月年
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900">
                            <td class="break-all">
                                {{ holderId }}<br>
                                {{ holderName }}
                            </td>
                            <td class="break-all">
                                {{ data.after.cardBankName }}
                            </td>
                            <td>
                                {{ formatCreditCardNo(data.after.cardNo) }}
                            </td>
                            <td>
                                {{ `${data.after.fullMonth}月 / ${data.after.fullYear}年` }}
                            </td>
                        </tr>
                    </template>
                </TableBase>
                <div class="text-right mt-4">
                    <button
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem]"
                        @click="goBackService(0)"
                    >
                        返回修改授權資料
                    </button>
                </div>
                <h4 class="mb-2.5 md:mb-4">
                    以下為此次欲申請信用卡授權的保單
                </h4>

                <TableBase
                    :isDashed="true"
                    :cursorPointer="false"
                >
                    <template #thead>
                        <tr class="text-sm lg:text-base">
                            <th>
                                保單號碼
                            </th>
                            <th class="hidden sm:table-cell">
                                被保險人
                            </th>
                            <th>
                                變更前繳費方式
                            </th>
                        </tr>
                    </template>
                    <template #tbody>
                        <tr
                            v-for="(item,index) in policyList"
                            :key="index"
                            class="text-base xs:text-lg md:text-base lg:text-lg text-gray-900"
                        >
                            <td class="break-all">
                                {{ item.fullPolicyNo }}
                            </td>
                            <td class="hidden sm:table-cell">
                                {{ item.name }}
                            </td>
                            <td>
                                {{ item.bankName + item.payKindText }}
                            </td>
                        </tr>
                    </template>
                </TableBase>
                <div class="text-right mt-4">
                    <button
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem]"
                        @click="goBackService(1)"
                    >
                        返回修改保單資訊
                    </button>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { computed, ref, toRef } from 'vue';
import { useRouter } from 'vue-router';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import codeList from '@/json/codeList.js';
import TableBase from '@/components/table/TableBase.vue';
import ResultList from '@/components/template/ResultList.vue';
import { formatCreditCardNo } from '@/utils/number/formatCreditCardNo';
import routeName from '@/router/constant';
import { useStore } from 'vuex';

export default {
    name: 'MultiENotifyData',
    components: {
        ResultList,
        CollapseConfirmData,
        TableBase
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const router = useRouter();
        const store = useStore();
        const code = ref(codeList.CREDIT_CARD_AUTH);
        const policyList = computed(() => data.value.after.policyList);
        const holderId = computed(() => store.state.permissions.userInfo.id).value;
        const holderName = computed(() => store.state.permissions.userInfo.name).value;
        const removeService = () => {
            emit('removeService', code.value);
        };
        const goBackService = (type) => {
            if (type === 0) {
                router.push({ name: routeName.CREDIT_CARD_AUTH_CARD_INFO });
            } else {
                router.push({ name: routeName.CREDIT_CARD_AUTH_POLICY });
            }
        };
        return {
            code,
            data,
            policyList,
            holderId,
            holderName,
            removeService,
            formatCreditCardNo,
            goBackService,
        };
    },
};
</script>
